module.exports = __webpack_public_path__ + "img/jiejue4.abe634b5.png";